// extracted by mini-css-extract-plugin
export default {"outline":"BorderAndLabel_outline__xtqn+","label":"BorderAndLabel_label__Z0+Ug"};